<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    primary: {
      type: Boolean,
      default: true,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Number, String],
      default: null,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
